/**
 * iter111 — WhatsApp Journey Badge (Calendar card + Voucher popup).
 *
 * A tiny pill that maps a conversation `current_status` to a coloured chip.
 * Read-only. Silent if no conversation exists (renders "Not Started" ⚪).
 */
import React from 'react';
import { MessageCircle } from 'lucide-react';

export const JOURNEY_STATUS_META = {
  not_started: {
    label: 'Not Started',
    dot: '⚪',
    className: 'bg-gray-100 text-gray-600 border border-gray-200',
  },
  waiting_confirmation: {
    label: 'Waiting Confirmation',
    dot: '🟡',
    className: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
  confirmed: {
    label: 'Confirmed',
    dot: '🟢',
    className: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  waiting_checkin_time: {
    label: 'Waiting Check-in Time',
    dot: '🟡',
    className: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
  checkin_time_received: {
    label: 'Time Received',
    dot: '🔵',
    className: 'bg-blue-50 text-blue-700 border border-blue-200',
  },
  journey_completed: {
    label: 'Journey Completed',
    dot: '✅',
    className: 'bg-emerald-100 text-emerald-800 border border-emerald-300',
  },
  cancel_requested: {
    label: 'Cancel Requested',
    dot: '🔴',
    className: 'bg-red-50 text-red-700 border border-red-200 font-semibold',
  },
};

export const WhatsAppJourneyBadge = ({ status, size = 'sm', bookingId }) => {
  const meta = JOURNEY_STATUS_META[status] || JOURNEY_STATUS_META.not_started;
  const sizeCls = size === 'lg' ? 'px-3 py-1.5 text-sm' : 'px-2 py-1 text-xs';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-lg ${sizeCls} ${meta.className}`}
      title={`WhatsApp: ${meta.label}`}
      data-testid={bookingId ? `wa-journey-badge-${bookingId}` : 'wa-journey-badge'}
      data-status={status || 'not_started'}
    >
      <MessageCircle className="w-3 h-3" />
      <span>{meta.dot}</span>
      <span>{meta.label}</span>
    </span>
  );
};

export default WhatsAppJourneyBadge;
